module.exports = __webpack_public_path__ + "76afce057089ebce0e99a0fef11880f2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/images/ic-like-active.svg
// module id = 1184
// module chunks = 2